import React from "react";
import profileImage from "assets/icons/username.svg?url";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { DestinationLogo } from "../../SelectDestination/destinations/DestinationLogo";
import { PlatformId } from "views/page-content/platforms/types";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import styles from "./index.module.scss";
import ChevronRight from "assets/icons/chevron-right.svg?react";

interface PlatformSubsettingsProps {
    destinations: { id: string; isDisabled?: boolean }[] | undefined;
    platformId: PlatformId;
    imgSrcKey: string;
    destinationNameKey: string;
    onDestinationClick(e: Required<{ id: string }>): void;
    headingText?: string;
}

function getNestedValue(obj: object, path: string): string {
    const valuePath = path.split(".");
    let curr: unknown = obj;
    for (let v of valuePath) {
        if (curr === null || curr === undefined || typeof curr !== "object") {
            return "";
        }
        curr = (curr as Record<string, unknown>)[v];
    }
    return typeof curr === "string" ? curr : "";
}

export const PlatformSubsettingsBase = ({
    destinations,
    platformId,
    imgSrcKey,
    destinationNameKey,
    onDestinationClick,
    headingText
}: PlatformSubsettingsProps) => {
    const { generalForm } = useSelector(
        (state: RootState) => state.platforms.general
    );

    if (!destinations?.length) {
        return <p>No destinations available.</p>;
    }

    return (
        <>
            {headingText && (
                <h6 className={styles["destination-title"]}>{headingText}</h6>
            )}
            <ul className={styles["subsetting-list"]}>
                {destinations.map((d, i) => {
                    const isDisabled =
                        generalForm.selectedSimulcastDestinations.some(
                            (sd) =>
                                sd.id === d.id ||
                                sd.id === d["switcher-stream-setting-id"]
                        );

                    const imgSrc = getNestedValue(d, imgSrcKey);
                    const destinationName = getNestedValue(
                        d,
                        destinationNameKey
                    );
                    const fullDestination: DestinationDescriptor = {
                        id: d.id,
                        logoUrl: imgSrc || profileImage,
                        name: destinationName || "Unknown Destination",
                        platform: platformId
                    };

                    return (
                        <li
                            key={d.id + i}
                            className={isDisabled ? styles.disabled : ""}
                            onClick={() => {
                                if (isDisabled) return;
                                onDestinationClick(fullDestination);
                            }}
                        >
                            <DestinationLogo destination={fullDestination} />
                            <h6>{destinationName}</h6>
                            <ChevronRight />
                        </li>
                    );
                })}
            </ul>
        </>
    );
};
